import { render, staticRenderFns } from "./ResultaatMatrix.vue?vue&type=template&id=1dd1d753"
import script from "./ResultaatMatrix.vue?vue&type=script&lang=js"
export * from "./ResultaatMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports